import React from "react";
import config from "lib/fr-config";
import ImageLoaderView from "presentational/common/ImageLoaderView";
import styles from "./CommonImageView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const colorCss = config.css.color;

CommonImageView.propTypes = {
  /** imageSrc 는 null 대신 "pending" 입력 받아야 한다. */
  imageSrc: PropTypes.string.isRequired,

  imageRatio: PropTypes.number.isRequired,
  increaseZIndex: PropTypes.bool,
  removeGlass: PropTypes.bool,

  colorType: PropTypes.oneOf(["default", "secondImageOfPair"]).isRequired
};

CommonImageView.defaultProps = {
  increaseZIndex: false,
  removeGlass: false,

  colorType: "default"
};

function CommonImageView(props) {
  const { imageSrc, imageRatio, increaseZIndex, removeGlass, colorType } =
    props;

  const getDynamicStyle = () => {
    return {
      backgroundColor:
        colorType === "secondImageOfPair"
          ? colorCss.backgroundColorOfSecondPairImage
          : colorCss.backgroundColorOfImage,
      paddingTop: `${(1 / imageRatio) * 100}%`
    };
  };

  return (
    <div className={cx("border-div")}>
      <div className={cx("image-grid")}>
        <div className={cx("detail-image-wrapper")} style={getDynamicStyle()}>
          {imageSrc !== "pending" && (
            <ImageLoaderView>
              <img
                className={cx("detail-image", {
                  "float-image": increaseZIndex
                })}
                alt=""
                src={imageSrc}
              />
            </ImageLoaderView>
          )}
          {!removeGlass && (
            <div
              className={cx("glass", {
                "float-image": increaseZIndex
              })}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CommonImageView;
